import { Col, Row } from 'antd';
import { FormikProps } from 'formik';
import { AccountApplicationCategoryView, EntityAccountType } from 'src/models';
import { Spacing } from 'src/styles';
import { getAccountApplicationCategoryDescription, getAccountApplicationCategorySampleDocument } from 'src/utils';

import { AccountApplicationCategoryBody } from './AccountApplicationCategoryBody';
import { AccountApplicationCategoryHeader } from './AccountApplicationCategoryHeader';
import { AccountApplicationFormValues } from './AccountApplicationForm';

interface AccountApplicationCategoryProps {
  category: AccountApplicationCategoryView;
  entityAccountType?: EntityAccountType;
  form: FormikProps<AccountApplicationFormValues>;
  testId?: string;
}

export const AccountApplicationCategoryInformation = ({
  category,
  entityAccountType,
  form,
  testId,
}: AccountApplicationCategoryProps) => {
  const sampleDocument = getAccountApplicationCategorySampleDocument({ category, entityAccountType });
  const description = getAccountApplicationCategoryDescription({ category, entityAccountType });

  return (
    <Row className={Spacing.mb12}>
      <Col span={24}>
        <AccountApplicationCategoryHeader
          title={category.name.label ?? ''}
          description={description}
          note={category.isResolved ? undefined : category.adminNote}
          sampleDocument={sampleDocument}
          testId={testId}
        />
      </Col>
      <Col span={24}>
        <AccountApplicationCategoryBody category={category} form={form} entityAccountType={entityAccountType} />
      </Col>
    </Row>
  );
};
